import { render } from "./AuraSidebar.vue?vue&type=template&id=7e4c23d2&ts=true"
import script from "./AuraSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraSidebar.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e4c23d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e4c23d2', __exports__)) {
    api.reload('7e4c23d2', __exports__)
  }
  
  module.hot.accept("./AuraSidebar.vue?vue&type=template&id=7e4c23d2&ts=true", () => {
    api.rerender('7e4c23d2', render)
  })

}


export default __exports__